import { observable } from 'mobx';

import { FetchOptions, SerializedData } from 'bernie-core';
import { AnalyticsStore } from 'bernie-plugin-mobx';
import { Sdk, VirtualAgentCheckoutStatus, VirtualAgentFlightCheckout } from '__generated__/api';
import analyticsWrapper from 'utility/analytics-wrapper';
import { Logger, NOOP_LOGGER, SystemEvent, SystemEventLevel } from 'bernie-logger';
import { BaseBexApiStore } from 'stores/bex-api-store';

export class VirtualAgentFlightCheckoutStore extends BaseBexApiStore {
  @observable public flightCheckoutInput: VirtualAgentFlightCheckout.Variables;
  public responseStatus: string;

  public hydrate(data: SerializedData): void {
    super.hydrate(data);
  }

  constructor(state: SerializedData = {}, logger: Logger = NOOP_LOGGER, api: Sdk) {
    super(state, logger, api);
  }

  public setCriteriaFromUrl(fetchOptions: FetchOptions) {
    const query = fetchOptions.query;
    const journeyContinuationId = query?.journeyContinuationId;
    const opaqueToken = query?.opaqueToken;
    const itineraryNumber = query?.itineraryNumber;
    this.flightCheckoutInput.flightsDetailsCriteria.journeyContinuationId = journeyContinuationId;
    this.flightCheckoutInput.virtualAgentContext.opaqueToken = opaqueToken;
    this.flightCheckoutInput.virtualAgentContext.itineraryNumber = itineraryNumber;
  }

  public fetchResults(
    virtualAgentVariable: VirtualAgentFlightCheckout.Variables,
    options: HeadersInit,
    analytics: AnalyticsStore
  ): Promise<VirtualAgentCheckoutStatus> {
    return this.api
      .VirtualAgentFlightCheckout(virtualAgentVariable, options)
      .then(response => {
        analyticsWrapper.publishAnalyticsPayload(response, analytics);
        const { status } = response?.data?.virtualAgentFlightCheckout ?? {};

        return status;
      })
      .catch(error => {
        this.logger.logEvent(new SystemEvent(SystemEventLevel.CRITICAL, 'VIRTUAL_AGENT_FLIGHT_CHECKOUT'), error);

        return null;
      });
  }
}

VirtualAgentFlightCheckoutStore.DEFAULTS = {
  responseStatus: null,
  flightCheckoutInput: {
    flightsDetailsCriteria: {
      journeyContinuationId: 'test'
    },
    virtualAgentContext: {
      itineraryNumber: 'test',
      opaqueToken: 'test'
    }
  }
};
